export interface PasswordValidation {
    minLength: boolean;
    hasNumber: boolean;
    hasLetter: boolean;
    isValid: boolean;
}

export function validateResetPassword(password: string): PasswordValidation {
    const minLength = password.length >= 8;
    const hasNumber = /\d|\W/.test(password);
    const hasLetter = /[A-Z]/.test(password) && /[a-z]/.test(password);
    return { minLength, hasNumber, hasLetter, isValid: minLength && hasNumber && hasLetter };
}
